// Removed axios dependency to make this package self-contained
// HTTP 응답 객체 인터페이스
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// HTTP 에러인지 확인하는 헬퍼 함수
function isHttpError(error) {
    return _instanceof(error, Error) && ('response' in error && _type_of(error.response) === 'object' || 'status' in error && typeof error.status === 'number');
}
// 기본 앱 에러 클래스
export var AppError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(AppError, Error1);
    function AppError(message) {
        var statusCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, errorCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'UNKNOWN_ERROR', details = arguments.length > 3 ? arguments[3] : void 0;
        _class_call_check(this, AppError);
        var _this;
        _this = _call_super(this, AppError, [
            message
        ]), _define_property(_this, "statusCode", void 0), _define_property(_this, "errorCode", void 0), _define_property(_this, "details", void 0);
        _this.statusCode = statusCode;
        _this.errorCode = errorCode;
        _this.details = details;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, AppError.prototype);
        return _this;
    }
    return AppError;
}(_wrap_native_super(Error));
// 구체적인 에러 타입들
export var AuthError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(AuthError, AppError);
    function AuthError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '인증이 필요합니다', errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'AUTH_REQUIRED';
        _class_call_check(this, AuthError);
        return _call_super(this, AuthError, [
            message,
            401,
            errorCode
        ]);
    }
    return AuthError;
}(AppError);
export var ValidationError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(ValidationError, AppError);
    function ValidationError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '입력값이 유효하지 않습니다', fieldErrors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, errorCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'VALIDATION_FAILED';
        _class_call_check(this, ValidationError);
        var _this;
        _this = _call_super(this, ValidationError, [
            message,
            400,
            errorCode
        ]), _define_property(_this, "fieldErrors", void 0);
        _this.fieldErrors = fieldErrors;
        return _this;
    }
    return ValidationError;
}(AppError);
export var NotFoundError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(NotFoundError, AppError);
    function NotFoundError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '요청한 리소스를 찾을 수 없습니다', errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'RESOURCE_NOT_FOUND';
        _class_call_check(this, NotFoundError);
        return _call_super(this, NotFoundError, [
            message,
            404,
            errorCode
        ]);
    }
    return NotFoundError;
}(AppError);
export var ServerError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(ServerError, AppError);
    function ServerError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '서버 오류가 발생했습니다', errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'SERVER_ERROR';
        _class_call_check(this, ServerError);
        return _call_super(this, ServerError, [
            message,
            500,
            errorCode
        ]);
    }
    return ServerError;
}(AppError);
export var ForbiddenError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(ForbiddenError, AppError);
    function ForbiddenError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '접근 권한이 없습니다', errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'ACCESS_DENIED';
        _class_call_check(this, ForbiddenError);
        return _call_super(this, ForbiddenError, [
            message,
            403,
            errorCode
        ]);
    }
    return ForbiddenError;
}(AppError);
export var ConflictError = /*#__PURE__*/ function(AppError) {
    "use strict";
    _inherits(ConflictError, AppError);
    function ConflictError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '리소스 충돌이 발생했습니다', errorCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'RESOURCE_CONFLICT';
        _class_call_check(this, ConflictError);
        return _call_super(this, ConflictError, [
            message,
            409,
            errorCode
        ]);
    }
    return ConflictError;
}(AppError);
// API 에러 변환 함수
export function convertApiError(error) {
    if (_instanceof(error, AppError)) {
        return error;
    }
    // HTTP 에러 객체인지 확인 (axios-free)
    if (isHttpError(error)) {
        var _httpError_response, _httpError_response1;
        var httpError = error;
        var status = ((_httpError_response = httpError.response) === null || _httpError_response === void 0 ? void 0 : _httpError_response.status) || httpError.status || 500;
        var data = (_httpError_response1 = httpError.response) === null || _httpError_response1 === void 0 ? void 0 : _httpError_response1.data;
        var message = (data === null || data === void 0 ? void 0 : data.message) || httpError.message || '서버 요청 중 오류가 발생했습니다';
        var errorCode = (data === null || data === void 0 ? void 0 : data.errorCode) || 'API_ERROR';
        switch(status){
            case 400:
                return new ValidationError(message, (data === null || data === void 0 ? void 0 : data.fieldErrors) || {}, errorCode);
            case 401:
                return new AuthError(message, errorCode);
            case 403:
                return new ForbiddenError(message, errorCode);
            case 404:
                return new NotFoundError(message, errorCode);
            case 409:
                return new ConflictError(message, errorCode);
            case 500:
            case 502:
            case 503:
            case 504:
                return new ServerError(message, errorCode);
            default:
                return new AppError(message, status, errorCode);
        }
    }
    return new AppError(_instanceof(error, Error) ? error.message : '알 수 없는 오류가 발생했습니다');
}
// API 요청 안전하게 처리하는 유틸리티
export function safeApiCall(apiCall) {
    return _safeApiCall.apply(this, arguments);
}
function _safeApiCall() {
    _safeApiCall = _async_to_generator(function(apiCall) {
        var result, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        apiCall()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        [
                            result,
                            null
                        ]
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        [
                            null,
                            convertApiError(error)
                        ]
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _safeApiCall.apply(this, arguments);
}
// 에러 로깅 유틸리티 (renamed to avoid conflict)
export function logAppError(error) {
    var appError = _instanceof(error, AppError) ? error : convertApiError(error);
    console.error("[".concat(appError.errorCode, "] ").concat(appError.message), {
        name: appError.name,
        statusCode: appError.statusCode,
        stack: appError.stack
    });
}
